import { useEffect, useState } from "react";
import { ValueType } from "rc-input/lib/interface";
import { useDebounce } from "use-debounce";

interface UseDebounceTextProps<T extends ValueType> {
	value: T;
	delay?: number;
	onDebouncedValue: (value: T) => void;
}

export const useDebounceInput = <T extends ValueType>({
	value,
	delay = 500,
	onDebouncedValue,
}: UseDebounceTextProps<T>) => {
	const [localValue, setLocalValue] = useState<T>();
	const [debouncedValue] = useDebounce(localValue, delay);

	useEffect(() => {
		setLocalValue(value);
	}, [value]);

	useEffect(() => {
		if (debouncedValue !== undefined) onDebouncedValue(debouncedValue);
	}, [debouncedValue, onDebouncedValue]);

	return { localValue, setLocalValue };
};
